<template>
    <div id="commonQuestionIndex" class="commonQuestionIndex">
        <div class="list-container">
            <el-menu
                :default-openeds="defaultOpen"
                :default-active="defaultActive"
                @select="handleSelect"
                overflow-y
                scroll
            >
                <template v-for="item in questionItems">
                    <el-submenu v-if="item.children && item.children.length > 0" :index="item.id">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span> {{ item.name }}</span>
                        </template>
                        <el-menu-item
                            v-for="(item2, index2) in item.children"
                            :index="`${item.id}-${item2.id}`"
                            :key="index2"
                        >
                            {{ item2.name }}
                        </el-menu-item>
                    </el-submenu>
                </template>
            </el-menu>
            list-container
        </div>

        <question
            v-if="questionListState && activeQuestion"
            :activeQuestion="activeQuestion"
            @questionMessage="questionMessage"
        >
        </question>
        <answer
            v-if="!questionListState && answerTxt"
            :activeQuestion="activeQuestion"
            :activeGroup="activeGroup"
            :answerTxt="answerTxt"
            @answerMessage="answerMessage"
        ></answer>
        <!--组件id =》 数据 =》 渲染 根据选中渲染对应的问题-->
    </div>
</template>

<script>
import Question from '../consoleLab/components/question';
import Answer from '../consoleLab/components/answer';
import { Data } from './data';
export default {
    name: 'commonQuestionIndex',
    components: { Question, Answer },
    component: {},
    data() {
        return {
            commonList: [0, 1, 2],
            currentCase: '',
            questionListState: true,
            questionItems: Data,
            activeQuestion: {},
            activeGroup: {},
            answerTxt: '',
            answerId: '',
            defaultActive: '',
            defaultOpen: [],
        };
    },
    methods: {
        handleSelect(key) {
            this.questionListState = true;
            const groupId = key.split('-')[0];
            const childId = key.split('-')[1];
            const mainData = Data.find((item) => item.id === groupId);
            const childData = mainData.children.find((name) => name.id === childId);
            // 问题 父节点
            this.activeGroup = mainData;
            // 子组件的问题内容
            this.activeQuestion = childData;
            this.updateHash();
        },
        questionMessage(id) {
            // 详情页内容
            this.answerTxt = this.activeQuestion.list.find((name) => name.id === id);
            this.answerId = id;
            this.questionListState = false;
            this.updateHash();
        },
        answerMessage() {
            this.answerId = '';
            this.questionListState = true;
            this.updateHash();
        },
        updateHash() {
            const groupId = this.activeGroup.id;
            const childId = this.activeQuestion.id;
            const infoId = this.answerId;
            const isInfo = !this.questionListState;
            if (isInfo && infoId) {
                this.$router.push({ hash: `${groupId}-${childId}&${infoId}` });
            } else {
                this.$router.push({ hash: `${groupId}-${childId}` });
            }
        },
        updateHashState() {
            let infoId = '';
            let isInfo = false;
            if (this.$route.hash === '') {
                this.activeGroup = this.questionItems[0];
                this.activeQuestion = this.questionItems[0].children[0];
            } else {
                const hash = this.$route.hash.split('#'); // ['', '1-1&0'];
                const content = hash[1]; // '1-1&0';
                const isAnswer = content.indexOf('&');

                let parentChild;

                if (isAnswer !== -1) {
                    const answerHash = content.split('&');
                    parentChild = answerHash[0];
                    infoId = answerHash[1];
                    if (infoId) {
                        isInfo = true;
                    }
                } else {
                    parentChild = content;
                }

                const groupId = parentChild.split('-')[0];
                const childId = parentChild.split('-')[1];

                let activeGroup = Data.find((item) => item.id === groupId);
                if (!activeGroup) {
                    activeGroup = this.questionItems[0];
                }
                let activeQuestion = activeGroup.children.find((name) => name.id === childId);
                if (!activeQuestion) {
                    activeQuestion = this.questionItems[0].children[0];
                }

                this.answerId = infoId;
                this.questionListState = !isInfo;
                this.activeGroup = activeGroup;
                this.activeQuestion = activeQuestion;
            }
        },
    },
    mounted() {
        this.updateHashState();
        this.defaultOpen = [this.activeGroup.id];
        this.defaultActive = `${this.activeGroup.id}-${this.activeQuestion.id}`;
        if (!this.questionListState) {
            this.questionMessage(this.answerId);
        }
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'

@media (max-width: 1080px)
  .commonQuestionIndex
    width 98% !important

.commonQuestionIndex
  height calc(100% - 60px)
  width 80%
  overflow hidden
  display flex
  margin 0 auto
  .list-container
    width 16%
    min-width 160px
    height 100%
    background-color $background-white
    overflow-y auto
    overflow-x hidden
  .list-container::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 1px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .list-container::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #f0f2f5;
  }
  .list-container::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
  }
.question-img
  width 100% !important
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/commonQuestion/commonQuestionIndex.vue